module.exports = __webpack_public_path__ + "static/EEG-Logo-ef57a8ea0d1395e0ee200b7a35178a47.png";